import httpService from "./httpService";

export default {
  deleteAttachment: async id => httpService.deleteRequest(`/documentAttachments/${id}`),
};
